import React from 'react';
import { Button } from 'react-bootstrap';
import BottomModal from './BottomModal';

export default function ConfirmModal({open, onClose, title, message, confirmText = 'Yes', cancelText = 'No', onConfirm, danger = false}) {
  return (
    <BottomModal
      open={open}
      onDismiss={onClose}
      header={<h3 className='mb-0'>{title}</h3>}
      footer={
        <div className="row">
          <div className='col-6'>
            <Button className='btn btn-lg mr-3 btn-secondary w-100' onClick={onClose}>
              {cancelText}
            </Button>
          </div>
          <div className='col-6'>
            <Button className={`btn btn-lg w-100 ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm}>
              {confirmText}
            </Button>
          </div>
        </div>
      }
    >
      <p>{message || 'Підтвердіть дію'}</p>
    </BottomModal>
  );
}
